/**
 * @Description 小天才的一项评分及预估销售额
 */

import React, { FC, useMemo } from 'react';
import { Typography } from 'antd';
import cs from 'classnames';
import styles from './index.module.less';
import { formatPredictSale, XTCScoreType } from '../../ts-config';
const { Text } = Typography;

const ScoreFourOwnScoreHasScore: FC<{
  scoreType: XTCScoreType; // 评分类型,区分xtc与bbg
  score: number; // 评分
  timeDimension: any; // 销售额预测时间单位类型
  salesAmountPredict: number; // 预测营业额
  showPredictIcon?: boolean; // 预测营业额前是否展示icon，横向空间充裕场景下设置为展示
  wrapperStyle?: React.CSSProperties; // 自定义组件整体style
  wrapperClassName?: string; // 自定义组件整体classname
  valWidth?: number; // 预测营业额（含单位）显示的宽度px
}> = ({
  scoreType,
  score,
  timeDimension,
  salesAmountPredict,
  showPredictIcon = false,
  wrapperStyle = {},
  wrapperClassName = '',
  valWidth,
}) => {

  const predictValue = useMemo(() => {
    return formatPredictSale(timeDimension, salesAmountPredict);
  }, [timeDimension, salesAmountPredict]);

  return (
    <div className={cs(styles.scoreAndPredict, wrapperClassName)} style={wrapperStyle}>
      <div className={styles.scoreWrapper}>
        <div className={styles.scoreName}>{scoreType === XTCScoreType.BBG ? '步步高' : '小天才'}</div>
        <div className={styles.scoreValue}>{score}</div>
      </div>
      {showPredictIcon ? <div className={cs(styles.illustrationImg, 'ml-20')}>
        <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/selectionmap/icon_predict.png`} width='100%' height='100%'/>
      </div> : <></>}
      <div className={showPredictIcon ? 'ml-6' : 'ml-10'}>
        <div>
          <Text
            style={{ width: valWidth ? `${valWidth}px` : '100%' }}
            ellipsis={{ tooltip: `${predictValue.val}${predictValue.unit}` }}
            className='fs-14 c-ff9 bold'
          >
            <span>
              {predictValue.val}
              <span className='c-222 fs-12 fwNormal'>{predictValue.unit}</span>
            </span>
          </Text>
        </div>
        <div className='fs-12 c-999 mt-2'>
          {predictValue.title}
        </div>
      </div>
    </div>
  );
};

export default ScoreFourOwnScoreHasScore;
